export const notifyBizStatusOptions = [
  {label: '已通知', value: 0},
  {label: '已成功', value: 1},
  {label: '异常', value: 10},
];


export const notifyBizStatusEnum = {
  started: 0,
  success: 1,
  error: 10,
};
